{
    "@metadata": {
        "authors": [
          "Nikolas Dahn"
        ],
        "last-updated": "2021-07-17",
        "locale": "en",
        "message-documentation": "qqq"
    },

    "seo-description": "Rocksi is a free robot simulator that runs in any modern browser and allows you to program a 3D robot arm using blockly visual programming.",
    "seo-header": "Simulate and program virtual robots in your browser!",
    "seo-text": "Rocksi is a simulator that allows you to freely program a 3D virtual robot similar to scratch or Lego Mindstorms. Rocksi runs on any modern browser (Firefox, Chrome, Safari...) and device (iPhone, iPad, IOS, Android, Linux, Windows, ...) - no download or installation! Rocksi is also completely free of charge with no registration required.<br>Rocksi was written to make robots more accessible for everybody, and especially with education in mind. Use it however you see fit, e.g. school classes, university lectures, workshops, fairs, etc.!At the moments robots by Franka Emika and Niryo are included, but it's easy to add new robots yourself (check the source code).",

    "robot-loading": "Loading Robot...",
    "warn-unsaved": "The current state will not be saved. Continue?",
    "note-code-export": "Code exported! Be careful before running this on your robot.",

    "tutorial-0-heading": "Welcome to Rocksi!",
    "tutorial-0-intro": "Robots are expensive, so for many people it's impossible to get to know them properly. But humans love touching things! Rocksi was created to make robots more accessible. Whether you're a teacher, a student, a specialist worker or just interested, Rocksi enables you to understand and share the very core concepts of robotics.",
    "tutorial-0-start": "To get started, click the arrow on the right to jump to the first tutorial.<br><i>I hope you enjoy!</i>",
    "tutorial-0-social": "Updates & Feedback",
    "tutorial-1-heading": "Organizing Yourself",
    "tutorial-1": "Quickly switch between views using the menu on the left.",
    "tutorial-2-heading": "Taking Perspective",
    "tutorial-2-desktop": "Use left click, right click and mouse wheel to move around.",
    "tutorial-2-mobile": "Use finger gestures to move around.",
    "tutorial-3-heading": "Taming the Robot",
    "tutorial-3": "Control the robot by clicking and dragging its gripper. You can control individual joints through the GUI in the top right.",
    "tutorial-4-heading": "Those Who Program",
    "tutorial-4": "By combining puzzle pieces from the toolbox you can quickly create a program for the robot.",
    "tutorial-5-heading": "Maintaining Posture",
    "tutorial-5": "Use the arrows to transfer poses between blocks and the robot.",
    "tutorial-6-heading": "Let it go",
    "tutorial-6": "To run your program just click the large play button in the 3D view.",
    "tutorial-7-heading": "Context is Everything",
    "tutorial-7": "The context menus give you additional control over your program. You can also load and save programs there!",
    "tutorial-rf-heading": "Robot Driver's License",
    "tutorial-rf": "You want to know more about robots? You can find some decent basic courses on {{link:robotikschulungen.de|https://www.robotikschulungen.de}} (unfortunately only in German right now).",

    "license-note": "Rocksi is distributed under the <a href=\"https://tldrlegal.com/license/mit-license\" target=\"_blank\">MIT license</a><br>",

    "imprint": "Imprint",
    "privacy": "Privacy Policy",
    "software": "Software",
    "robots": "Robots",
    "imprint-content": "i18n/imprint_en.html",
    "privacy-content": "i18n/privacy_en.html",
    "software-content": "i18n/software_en.html",
    "robots-content": "i18n/robots_en.html",

    "gui-robot": "Rocksi",
    "gui-language": "Language",
    "gui-gripper": "Gripper",
    "gui-gripper-open": "Open",
    "gui-gripper-close": "Close",
    "gui-advanced-gripping": "Realistic Grip",
    "gui-joints": "Joint Values",
    "gui-ik-joints": "IK Joints",
    "gui-reset-robot": "Reset Robot",
    "gui-reset-view": "Reset Viewport",
    "gui-close": "Close",
    "gui-confirm-switch-robot": "Are you sure you want to load the $1 robot? Any unsaved programs will be lost!",
    "gui-confirm-switch-language": "Are you sure you want to change language? Any unsaved programs will be lost!",
    "gui-robot-info": "Info",

    "franka-info": "Franka Emika's robot features 7 joint degrees of freedem as well as a high degree of sensitivity. This allows it to move similar to a human arm and react to even light touches. <p><a href=\"https://franka.de/\" target=\"_blank\">www.franka.de</a></p>",
    "niryo-info": "Niryo creates robots with 6 joints that are meant to be used in education. The robot is open source, so if you have the parts and a 3d printer you can even build it yourself! <p><a href=\"https://niryo.com/\" target=\"_blank\">www.niryo.com</a></p>",
    "sawyer-info": "The Sawyer is the successor of the two-armed Baxter robot and is very popular in research. The arrangements of joints creates some very unusual movement patterns! <p><a href=\"https://www.rethinkrobotics.com/sawyer/\" target=\"_blank\">www.rethinkrobotics.com/sawyer/</a></p>"
}